"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _iconNames = _interopRequireDefault(require("../../../constants/iconNames"));

var _button = require("../../../styles/2_commonComponentStyles/button");

var _IconBubbleLink = require("./IconBubbleLink.styles");

var _Icon = _interopRequireDefault(require("../../IconicDisplayElements/Icon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * IconBubbleLink - for when you need the IconBubble to link to something (like a phone number)
 */
// intentionally left as a functional component
var IconBubbleLink = function IconBubbleLink(_ref) {
  var className = _ref.className,
      dataTestId = _ref.dataTestId,
      disabled = _ref.disabled,
      iconName = _ref.iconName,
      text = _ref.text,
      url = _ref.url,
      props = _objectWithoutProperties(_ref, ["className", "dataTestId", "disabled", "iconName", "text", "url"]);

  var content = iconName ? /*#__PURE__*/_react.default.createElement(_Icon.default, {
    iconName: iconName,
    dataTestId: "icon-bubble-link-icon"
  }) : /*#__PURE__*/_react.default.createElement("span", {
    "data-test-id": "icon-bubble-text-text"
  }, text);
  return /*#__PURE__*/_react.default.createElement(_IconBubbleLink.StyledIconBubbleLink, _extends({
    className: "".concat(className, " ").concat(disabled ? 'c-button-disabled' : ''),
    "data-test-id": dataTestId,
    href: !disabled && url ? url : null
  }, props), content);
};

IconBubbleLink.propTypes = {
  /** Hook for overriding top-level component styles */
  className: _propTypes.default.string,

  /** Used to pick the color theme to apply to the button - One of:
   * undefined,
   'primary',
   'tertiary',
   'cta',
   'overDark',
   */
  colorTheme: _propTypes.default.oneOf(_button.buttonColorThemes),

  /** Test ID hook */
  dataTestId: _propTypes.default.string.isRequired,

  /** disabled handles button interactivity */
  disabled: _propTypes.default.bool,

  /** iconName - reflects string name of fontawesome icon - see 'constants/iconNames' for the full list */
  iconName: _propTypes.default.oneOf(_iconNames.default),

  /** flag to denote that the component cannot be interacted with.
   * This differs from disabled in that the component looks enabled, but will not have hover, active, etc applied to it.
   */
  inactive: _propTypes.default.bool,

  /** text - text layed on top of the button */
  text: _propTypes.default.string,

  /** url for the link */
  url: _propTypes.default.string
};
IconBubbleLink.defaultProps = {
  className: '',
  colorTheme: 'primary',
  disabled: false,
  iconName: '',
  inactive: false,
  text: undefined,
  url: null
};
var _default = IconBubbleLink;
exports.default = _default;